import { render, staticRenderFns } from "./TickerAdminAddPortfolio.vue?vue&type=template&id=0af4513a"
import script from "./TickerAdminAddPortfolio.vue?vue&type=script&lang=js"
export * from "./TickerAdminAddPortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports